import { Col, Row } from 'antd';
import styled from 'styled-components';
import StatesWidgetSkeleton from 'Components/common/skeleton/StatesWidgetSkeleton';
import ArticleHeroSkeleton from 'Components/common/skeleton/ArticleHeroSkeleton';
import ArticleTileSkeleton from 'Components/common/skeleton/ArticleTileSkeleton';

import TagSkeleton from 'Components/common/skeleton/TagSkeleton';
import ProgressBarSkeleton from 'Components/common/skeleton/ProgressBarSkeleton';
import {
  boxShadow, maxMobile, maxWidth, primaryHeadingColor, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import { IsTablet } from 'Utils/UtilityFunctions';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

const StyleWrapper = styled.div`
 .spotlight-wrapper{
   background-color: #fff;
   border-radius:16px;
   padding: 24px 24px;
   box-shadow: ${boxShadow};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius:12px;
      padding-top:16px;
      padding-bottom:16px;
    }
    @media all and (max-width: ${maxMobile} ) {
      padding: 24px 10px;
    }
  }
  .heading-inner-page {
    display: flex;
    align-items: center;
    justify-content: space-between;
   .heading {
     font-size: 28px;
     font-family: ${secondaryFont};
     font-weight: ${wMBold};
     color: ${primaryHeadingColor};
     margin-bottom: 0px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
     }
   }
  }
`;

const SpotlightFullSkeleton = function SpotlightFullSkeleton() {
  return (
    <StyleWrapper>
      <div className="spotlight-wrapper spotlight-unique-class">
        <div className="heading-inner-page">
          <h1 className="heading">Spotlight</h1>
          <div className="tips-placeholder-spotlight">
            <TagSkeleton />
            <TagSkeleton />
          </div>
        </div>

        <div className="progress-wrapper">
          <ProgressBarSkeleton />
        </div>

        {IsTablet() ? (
          <SkeletonCustom
            height="400px"
            width="100%"
            margin="0px 0px 0px 0px"
            marginSm="0px 0px 0px 0px"
            logo
          />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={14}>
                <Row gutter={16}>
                  <Col span={14}>
                    <ArticleHeroSkeleton />
                  </Col>
                  <Col span={10}>
                    <ArticleHeroSkeleton />
                  </Col>
                </Row>
              </Col>
              <Col span={10}>
                <Row gutter={16}>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                </Row>
                <span className="resolution-fix spotlight-article-skelton">
                  <ArticleTileSkeleton />
                  <ArticleTileSkeleton />
                </span>
              </Col>
            </Row>
            <Row gutter={16} className="mt-c-15">
              <Col span={12}>
                <ArticleTileSkeleton />
              </Col>

              <Col span={12}>
                <ArticleTileSkeleton />
              </Col>
            </Row>
          </>
        )}

      </div>
    </StyleWrapper>
  );
};

export default SpotlightFullSkeleton;
